<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import productForm from "./forms/product-form.vue";
import productShow from "./show/show.vue";
import productFilesShow from "./show/product-files-show.vue";
import CustomTable from "@/components/tables/custom-table.vue";
import AddButton from "@/components/buttons/add-button.vue";
import Status from "@/helpers/general/status";
import SelectAutocompleteField from "@/components/forms/select-autocomplete-field.vue";


/**
 * Customers Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AddButton,
    productForm,
    productShow,
    productFilesShow,
    CustomTable,
    SelectAutocompleteField,
  },
  data() {
    return {
      formModalId:'product-form-modal',
      showModalId:'product-show-modal',
      filesModalId:'product-files-modal',
      pageHeader:{
        title: "Productos",
        breadcrumbs: [
          {
            text: "Productos",
            href: "/products",
            active: true
          }
        ],
      },
      product_status: Status.getList('products'),
      table:{
        url:'/products',
        params: {
          'with_trashed': 1,
        },
        fields:[
          { key: "id", label: "Cod", sortable: true },
          { key: "name", label: "Nombre", sortable: true },
          { key: "sku", label: "SKU", sortable: true },
          { key: "slug", label: "Slug", sortable: true },
          { key: "integration.name", label: "Origen", sortable: false },
          { key: "status", label: "Estado", sortable: true },
        ],
        formatted_fields:[
          'status'
        ]
      },
      formSelectedItemId:null,   
      showSelectedItemId:null,
      showSelectedItem:null,
      clone:false
    };
  },
  methods: {
    showEditModal(item, clone = false) {
      this.formSelectedItemId = item?.id || null;
      this.clone = clone;
      this.$nextTick(() => {
        this.$bvModal.show(this.formModalId);
      });
    },
    showViewModal(item) {
      this.showSelectedItemId = item?.id || null;
      this.$bvModal.show(this.showModalId);
    },
    showFilesModal(item) {
      this.showSelectedItem = item || null;
      this.$bvModal.show(this.filesModalId);
    },
    onSuccess(){
      this.$refs.customerTable.refresh();
    },
    canCloneProduct(item) {
      return !item?.integration_id;
    },
    formatter(field, item){
      if(field === 'status'){
        const status = Status.getStatus({itemStatus: item?.status, type: 'products'});
        return status;
      }
      return '';
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <productForm :modal-id="formModalId" :id="formSelectedItemId" @onSuccess="onSuccess" :clone="clone" @onHidden="clone = false"></productForm>
            <productShow :modal-id="showModalId" :id="showSelectedItemId"></productShow>
            <productFilesShow :modal-id="filesModalId" :product="showSelectedItem"></productFilesShow>
            <CustomTable
              :url="table.url"
              :fields="table.fields"
              :formatted-fields="table.formatted_fields"
              :formatter="formatter"
              :params="table.params"
              @edit="showEditModal"
              ref="customerTable"
              :show-view="false"
              :showSoftDelete="false"
              @show="showViewModal"
              :show-modal-id="showModalId"
            >
              <template v-slot:header-actions>
                <AddButton @click="showEditModal"></AddButton>
              </template>
              <template v-slot:before-custom-actions="slotProps">
                <a href="javascript:void(0);"
                  class="mr-3"
                  :class="canCloneProduct(slotProps.row?.item) ? 'text-primary' : 'text-secondary'"
                  v-b-tooltip.hover
                  :title="canCloneProduct(slotProps.row?.item) ? 'Clonar' : 'Solo es posible clonar productos creados manualmente'"
                  @click="canCloneProduct(slotProps.row?.item) ? showEditModal(slotProps.row?.item, true) : null"
                  v-has-permission="{ permission: 'products.create', action: 'disable' }">
                  <i class="mdi mdi-content-copy font-size-18"></i>
                </a>
                <a href="javascript:void(0);" 
                  class="mr-3" 
                  :class="slotProps.row?.item?.allow_files ? 'text-primary' : 'text-secondary'"
                  v-b-tooltip.hover 
                  :title="slotProps.row?.item?.allow_files ? 'Gestionar archivos' : 'No permitido'"
                  @click="slotProps.row?.item?.allow_files ? showFilesModal(slotProps.row?.item) : null">
                  <i class="ri-file-list-line font-size-18"></i>
                </a>
              </template>
              <template v-slot:filters="{ filters }">
                <div class="row">
                    <div class="form-group col-12 col-lg-4 col-sm-6">
                        <label for="sku">SKU</label>
                        <input id="sku" v-model="filters.sku" type="text" class="form-control" placeholder="Ingresa un SKU para filtrar"/>
                    </div>
                    <div class="form-group col-12 col-lg-4 col-sm-6">
                        <label for="sku">Estado</label>
                        <select v-model="filters.status" class="form-control" placeholder="Todos">
                            <option value="">Todos</option>
                            <option v-for="option in product_status" v-bind:value="option.id" :key="option.id">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-lg-4 col-sm-6">
                        <label for="name">Origen</label>
                        <SelectAutocompleteField :url="`/integrations`" :only-ids="true" :multiple="true" :placeholder="'Todos'" v-model="filters.integration_id"></SelectAutocompleteField>
                    </div>
                </div> 
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>